<template>
  <component :is="!context.isMobile ? DropdownMenuItem : DrawerClose" as-child>
    <a
      :href="props.href"
      target="_blank"
      rel="noopener noreferrer nofollow"
      :class="[
        'group/item',
        'relative flex shrink-0 cursor-pointer select-none items-center gap-3 self-stretch rounded-md border-none px-3 outline-none',
        'text-left text-sm text-current',
        !context.isMobile ? 'py-1' : 'py-2',
        'active:bg-menu-muted data-[highlighted]:bg-menu-muted',
      ]"
    >
      <slot v-if="slots.icon" name="icon" />
      <component
        :is="iconMappingMicro[props.icon]"
        v-else-if="props.icon"
        class="size-4 shrink-0 text-menu-muted-foreground transition-colors"
      />

      <span class="min-w-0 grow break-words">
        {{ props.label }}
      </span>

      <ArrowUpRightIcon
        v-if="href"
        class="size-4 shrink-0 text-menu-muted-foreground"
      />
    </a>
  </component>
</template>

<script setup lang="ts">
import { DropdownMenuItem } from "reka-ui";
import { DrawerClose } from "vaul-vue";

import ArrowUpRightIcon from "@/icons/heroicons/arrow-up-right-micro.svg";
import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";

import { inject } from "./context";

const context = inject();

const props = defineProps<{
  label: string;
  icon?: MappedIconMicro;
  href?: string;
}>();

const slots = defineSlots<{
  icon?(): unknown;
}>();
</script>
